import Api from "../api";
let uri = '/api/ed/campania';

export const getTipoCampania = () => {
    return Api.getInstance().executeGetQuery(`${uri}/tipo`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const getCampanias = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const adminCampanias = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const getHorariosCampania = () => {
    return Api.getInstance().executeGetQuery(`${uri}/horario`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const getEventosCampania = () => {
    return Api.getInstance().executeGetQuery(`${uri}/eventos`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const adminEventos = (data) => {
    return Api.getInstance().executeQuery(`${uri}/evento`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const clientesCampania = (data) => {
    return Api.getInstance().executeQuery(`${uri}/cliente`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const verificarHorarioCampania = (data) => {
    return Api.getInstance().executeQuery(`${uri}/verify`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}